export const routesWithFilterAsSearchParams = ['/settings/staff/profile'];
